import { getDocument, GlobalWorkerOptions, version } from 'pdfjs-dist';

// Configure PDF.js worker
if (typeof window !== 'undefined') {
  GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${version}/pdf.worker.min.js`;
}

export async function extractTextFromPDF(file: File): Promise<string> {
  try {
    const arrayBuffer = await file.arrayBuffer();
    const pdf = await getDocument({ data: arrayBuffer }).promise;
    let fullText = '';
    
    for (let i = 1; i <= pdf.numPages; i++) {
      const page = await pdf.getPage(i);
      const content = await page.getTextContent();
      const text = content.items.map((item: any) => item.str).join(' ');
      fullText += text + '\n';
    }
    
    return fullText.trim();
  } catch (error) {
    console.error('Error parsing PDF:', error);
    throw new Error('Failed to parse PDF file');
  }
}

export async function parseResumeFile(file: File): Promise<string> {
  try {
    let text: string;
    
    if (file.type === 'application/pdf') {
      const arrayBuffer = await file.arrayBuffer();
      const typedArray = new Uint8Array(arrayBuffer);
      
      const loadingTask = getDocument({
        data: typedArray,
        cMapUrl: `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${version}/cmaps/`,
        cMapPacked: true,
      });
      
      const pdf = await loadingTask.promise;
      let fullText = '';
      
      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const content = await page.getTextContent();
        fullText += content.items.map((item: any) => item.str).join(' ') + '\n';
      }
      
      text = fullText.trim();
    } else if (file.type === 'text/plain') {
      text = await file.text();
    } else if (file.type === 'application/msword' || 
               file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
      text = await file.text();
    } else {
      throw new Error(`Unsupported file type: ${file.type}`);
    }
    
    if (!text || text.trim().length === 0) {
      throw new Error('No text content found in the file');
    }
    
    return text;
  } catch (error) {
    console.error('Error in parseResumeFile:', error);
    throw new Error('Failed to parse file. Please try again or use a different format.');
  }
} 